import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import Colours from './Colours';

const ColoursWithLink = (props) => {
    return <Colours Wrapper={SingleColourWithLink} {...props} />;
};

ColoursWithLink.propTypes = {};
export default ColoursWithLink;

/* an individual swatch with LINK */
const SingleColourWithLink = (props) => {
    const { productUrl, onClick = () => {}, partNumber, position, children, title } = props;

    return (
        <NavLink to={productUrl} title={title} onClick={() => onClick(partNumber, position)} replace={true}>
            {children}
        </NavLink>
    );
};

SingleColourWithLink.propTypes = {
    locale: PropTypes.string.isRequired,
    partNumber: PropTypes.string,
    children: PropTypes.any.isRequired,
    position: PropTypes.number,
    onClick: PropTypes.func,
    title: PropTypes.string,
};
